export default __webpack_public_path__ + "static/media/2.6ff62b99.png";